import React, { useState } from 'react';
import CountUp from 'react-countup';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { AverageSpending, AverageVisit } from './AreaCharts';
import { CustomerLifeTimeValue } from './ColumnCharts';
import { MostEngagedCategories } from './BarCharts';
import {
  EngagedScore,
  HeighLtv,
  Recommended,
  PurchaseFrequency,
  ConvenienceShopper,
  Churn,
} from './RadialbarCharts';
import { Link } from 'react-router-dom';
import barCode from '../../../../assets/images/ahlanBarCode.svg';
import { ChannelPreference, DevicesUsage } from './ECharts';
import Barcode from 'react-barcode';
import { formatDate } from '../../../../helpers/formatDate';

const UserAttributes = ({ member, setActiveTab }) => {
  const { rewards = {}, country = 'ae' } = member;

  const userProperties = {
    'Tracked Standard Attribute': [
      { name: 'Email (Standard)', value: member.email },
      { name: 'First Name', value: member.firstName },
      { name: 'ID', value: member.id },
      { name: 'Last Name', value: member.lastName },
      { name: 'Mobile Number (Standard)', value: member.mobileNumber },
      { name: 'Name', value: `${member.firstName} ${member.lastName}` },
    ],

    Localization: [
      { name: 'Last Known City', value: member.city },
      { name: 'Last Known Country', value: member.country },
      { name: 'Last Known Pincode', value: member.pincode },
      { name: 'Last Known State', value: member.state },
      { name: 'User Time Zone Offset (Mins)', value: member.timeZoneOffset },
    ],
  };

  const renderPropertyGroup = (groupTitle, items) => (
    <Col md="6" className="mb-4" key={groupTitle}>
      <Card>
        <CardHeader>{groupTitle}</CardHeader>
        <CardBody>
          <table className="table">
            <thead>
              <tr>
                <th>Property Name</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </Col>
  );

  return (
    <Container fluid>
      <Row>
        {Object.entries(userProperties).map(([groupTitle, items]) =>
          renderPropertyGroup(groupTitle, items)
        )}
      </Row>
    </Container>
  );
};

export default UserAttributes;
